import { styled } from '../../Utilities';
import { getStyles } from './ExpandingCard.styles';
import { ExpandingCardBase } from './ExpandingCard.base';
export var ExpandingCard = styled(ExpandingCardBase, getStyles, undefined, {
    scope: 'ExpandingCard',
});
//# sourceMappingURL=ExpandingCard.js.map